import { useState } from 'react';
import CreateCoupon from './createCoupon';
import CouponsTable from './couponsTable';
import Button from 'components/button';

const Coupon = () => {
  const [showForm, setShowForm] = useState(false);

  const handleToggleFormVisibility = () => {
    setShowForm((prevState) => !prevState);
  };

  return (
    <div>
      <Button
        onClick={handleToggleFormVisibility}
        extraClasses="ml-auto mr-4 mb-4"
      >
        {showForm ? 'Back' : 'Add New Coupon'}
      </Button>
      {showForm ? <CreateCoupon /> : <CouponsTable />}
    </div>
  );
};

export default Coupon;
